import { HTTP_TOKEN } from "./http";

export const getTags = (params) => {
  return HTTP_TOKEN.get("tag", { params }).then((result) => {
    return result.data;
  });
};

export const createTag = (data) => {
  return HTTP_TOKEN.post("tag", data).then((result) => {
    return result.data;
  });
};


export const updateTag = (tag_id, data) => {
  return HTTP_TOKEN.put(`tag/${tag_id}`, data).then((result) => {
    return result.data;
  });
};

export const removeTag = (tag_id) => {
  return HTTP_TOKEN.delete(`tag/${tag_id}`).then((result) => {
    return result.data;
  });
};
